import {Button, Tooltip} from '@mantine/core'
import type {ReactNode} from 'react'

import {useEditRights} from 'src/jobs/edit-rights-context'

type GroupActionButtonProps = {
    hint: string
    enabled: boolean
    onClick: () => void
    children: ReactNode
}

export function GroupActionButton({hint, enabled, onClick, children}: GroupActionButtonProps) {
    const {canDispatch} = useEditRights()
    if (!canDispatch) {
        return null
    }

    return (
        <Tooltip label={hint} disabled={enabled}>
            <span>
                <Button size="compact-xs" variant="light" disabled={!enabled} onClick={onClick}>
                    {children}
                </Button>
            </span>
        </Tooltip>
    )
}
